import { app } from '@/store';
import type { IDataSettings, IDataAtomSetting, IData } from './interface';

export class DataSettings implements IDataSettings {
  public dataSettingAtom: IDataAtomSetting;

  constructor(id: string) {
    this.init(id);
  }
  init(id: string) {
    this.dataSettingAtom = this.getDataSettingAtomById(id);
    return;
  }
  getId(): string {
    return this.dataSettingAtom.id;
  }
  getKey(): string {
    return this.dataSettingAtom.key;
  }
  getLabel(): string {
    return this.dataSettingAtom.label;
  }
  getType(): string {
    return this.dataSettingAtom.type;
  }
  getData(): IData {
    return this.dataSettingAtom.data || {};
  }

  setData(dataSettingAtom?: IDataAtomSetting) {
    if (!dataSettingAtom) {
      dataSettingAtom = this.dataSettingAtom;
    }
    (app as any).$store.commit('editor/SET_DATA_SETTINGS', {
      id: this.getId(),
      value: JSON.stringify(dataSettingAtom),
    });
    return true;
  }
  mergeDataForDataSettingAtom(data: IData) {
    this.dataSettingAtom.data = data;
    this.setData();
    return false;
  }

  getDataSettingAtomById(id: string): IDataAtomSetting {
    const isExistEditorInfo = (app as any).$store.getters['editor/EXIST_KEY_DATA_SETTING'](id);
    if (!isExistEditorInfo) return {} as IDataAtomSetting;
    const dataEditorInfo = (app as any).$store.getters['editor/GET_DATA_SETTING_BY_KEY'](id);
    const parseData = dataEditorInfo && JSON.parse(dataEditorInfo);
    return parseData;
  }
  setDataSettingAtomById(id: string): IDataAtomSetting {
    const isExistEditorInfo = (app as any).$store.getters['editor/EXIST_KEY_DATA_SETTING'](id);
    if (!isExistEditorInfo) return {} as IDataAtomSetting;
    const dataEditorInfo = (app as any).$store.getters['editor/GET_DATA_SETTING_BY_KEY'](id);
    const parseData = dataEditorInfo && JSON.parse(dataEditorInfo);
    return parseData;
  }
}
